<div class="container">
  <div class="content">
    <div class="dialog-headline">
      <h3>Create validation rules for {{ fileTypeName }}</h3>
    </div>

    <div class="box">
      <div class="group">
        <p>
          The following list represents the fixed schema of the file type. For each attribute a validation rule can be
          defined. The rules need to be
          <span>passed</span>
          - otherwise they will be listed as violations for each upload.
        </p>
        <div class="flex-container">
          <ci-simple-table
            class="mat-elevation-z4"
            [externalDataList]="schema"
            [header]="schemaHeader"
            [hidePagination]="true"
            [loading]="loading">
            <ng-template
              #columns
              let-item>
              <div class="content-column">
                <p>
                  {{ item.attribute }}
                </p>
              </div>
              <div class="content-column">
                <p>
                  {{ item.type }}
                </p>
              </div>
              <div class="content-column">
                <coin-dropdown
                  style="padding-bottom: 0px !important"
                  [items]="getOperatorList(item)"
                  [shadow]="true"
                  [canDeselect]="true"
                  [disabled]="!getOperatorList(item).length"
                  [(ngModel)]="item.operator"
                  (pressApplyChanges)="onDropdownChange(item)"></coin-dropdown>
              </div>
              <div class="content-column">
                <coin-v2-text-input
                  [placeholder]="'value'"
                  [disabled]="disableCompareValue(item)"
                  [(ngModel)]="item.compareValue"></coin-v2-text-input>
                @if (missingCompareValue(item)) {
                  <p class="missing-text">a value must be entered</p>
                }
                @if (invalidParseableNumber(item)) {
                  <p class="missing-text">value must be a valid number</p>
                }
              </div>
              <div class="content-column">
                <coin-v2-text-input
                  [placeholder]="'name of custom validation'"
                  [disabled]="!item.operator"
                  [(ngModel)]="item.validationName"></coin-v2-text-input>
                @if (invalidValidationName(item)) {
                  <p class="missing-text">a value must be entered</p>
                }
              </div>
            </ng-template>
            <ng-template #noData>
              <p>no data</p>
            </ng-template>
          </ci-simple-table>
        </div>

        <div class="buttons">
          <coin-v2-button
            [type]="'secondary'"
            [icon]="'close'"
            [text]="'Cancel'"
            [iconPos]="'right'"
            (click)="close()"></coin-v2-button>
          <coin-v2-button
            [type]="'primary'"
            [icon]="'save'"
            [text]="'Save'"
            [iconPos]="'right'"
            [disabled]="loading || hasInputErrors()"
            (click)="save()"></coin-v2-button>
        </div>
      </div>
    </div>
  </div>
</div>
